import { useLocation } from "react-router-dom";
import { useMemo } from "react";
import { FiltersObject, isQueryParameter, VqlQuery } from "types";
import {
  AUTOMATIC_FLAT_RESPONSE_PARAMETER,
  FLAT_RESPONSE_PARAMETER,
  VQL_PARAMETER,
} from "helpers/constants/miscellaneous";
import { extractValuesFromVqlQueries } from "helpers/utility/vqlHelpers";

function useAllQueryParamsFilters(): FiltersObject {
  const { search } = useLocation();

  return useMemo(() => {
    const params = new URLSearchParams(search);
    const filtersObject: FiltersObject = {};

    // Process regular query parameters
    params.forEach((value, key) => {
      if (isQueryParameter(key)) {
        filtersObject[key] = decodeURIComponent(value);
      }
    });
    if (params.has(AUTOMATIC_FLAT_RESPONSE_PARAMETER)) {
      filtersObject[FLAT_RESPONSE_PARAMETER] = decodeURIComponent(
        params.get(AUTOMATIC_FLAT_RESPONSE_PARAMETER)!,
      );
    }

    // Also extract values from VQL parameter
    const vqlParam = params.get(VQL_PARAMETER);
    if (vqlParam) {
      try {
        const vqlQueries = JSON.parse(vqlParam) as VqlQuery[];
        const extractedValues = extractValuesFromVqlQueries(vqlQueries);

        // Merge extracted values into filtersObject
        Object.assign(filtersObject, extractedValues);
      } catch (error) {
        console.error("Error parsing VQL parameter:", error);
      }
    }

    return filtersObject;
  }, [search]);
}

export default useAllQueryParamsFilters;
